<template>
  <tbody class="period">
    <moment-input-tr
      label="Begin"
      v-model="begin"
      :min="beginMin"
      class="begin"
    />

    <moment-input-tr
      label="End"
      v-model="end"
      :min="endMin"
      class="end"
    />
  </tbody>
</template>

<script>
/**
 * @typedef { import('../../time.js').DatePeriodObject } DatePeriodObject
 */

import MomentInputTr from './MomentInputTr.vue';

export default {
  name: 'PeriodInput',

  components: {
    MomentInputTr
  },

  props: {
    value: {
      required: true,
    },

    // Date or String
    beginMin: {},

    // Date or String
    endMin: {},
  },

  data() {
    const moment = this.value;

    return {
      begin: moment.begin, // Date
      end:   moment.end,   // Date
    };
  },

  watch: {
    begin() {
      this.emitInput();
    },

    end() {
      this.emitInput();
    },
  },

  methods: {
    emitInput() {
      /** @type {DatePeriodObject} */
      const period = {
        begin: this.begin,
        end:   this.end,
      };

      this.$emit('input', period);
    }
  }
};
</script>

<style scoped>
.begin >>> th,
.begin >>> td {
  padding-bottom: .34rem;
}
</style>
